import { ReactNode } from "react";

/**
 * Status de importação de BOM conforme modelo BomImportJob do backend
 */
export enum ImportStatus {
  PENDING = "PENDING",
  RUNNING = "RUNNING",
  DONE = "DONE",
  FAILED = "FAILED",
  ERROR = "ERROR",
  WAITING = "WAITING",
  STARTED = "STARTED",
  FINISHED = "FINISHED",
}

/**
 * Informações de uma importação em progresso
 */
export interface ImportInfo {
  id: number;
  status: ImportStatus;
  progress: number;
  total_rows?: number;
  processed_rows?: number;
  remaining_seconds?: number;
  elapsed?: number;
  message?: string;
  error_message?: string;
  error?: string;
  origin?: "SAP" | "PLANILHA" | string;
}

/**
 * Dados recebidos nas mensagens do WebSocket
 */
export interface ImportMessageData {
  id: number;
  status: ImportStatus;
  progress: number;
  total_rows?: number;
  processed_rows?: number;
  remaining_seconds?: number;
  elapsed?: number;
  message?: string;
  error_message?: string;
  error?: string;
}

/**
 * Tipos de mensagens enviadas pelo WebSocket de importação
 */
export type ImportMessageType =
  | "import_bom_progress"
  | "import_stock_and_po_progress"
  | "import_boms"
  | "import_stock_and_po";

/**
 * Estrutura de mensagem recebida do WebSocket
 */
export interface ImportWebSocketMessage {
  type?: ImportMessageType;
  action?: string;
  is_importing?: boolean;
  data?: ImportMessageData;
  error?: string;
}

/**
 * Props do provider de importação
 */
export interface ImportProviderProps {
  children: ReactNode;
}
